import styled from 'styled-components';

import CheckIcon from '../../../../assets/icons/check.svg';
import CloseIcon from '../../../../assets/icons/close.svg';
import PhoneIcon from '../../../../assets/icons/secondary/Call.svg';
import MailIcon from '../../../../assets/icons/secondary/Message.svg';
import {ms} from '../../../../styles/normalizeSize';
import {getColor} from '../../../../styles/utils';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-bottom: ${ms(10)};
`;

export const Content = styled(View)`
  flex: 1;
`;

export const ContentContainer = styled(View)`
  flex: 1;
  flex-direction: row;
  align-items: center;
`;

export const Icon = styled(({type, ...rest}) => {
  const Component = type === 'email' ? MailIcon : PhoneIcon;

  return <Component {...rest} />;
}).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  width: ${ms(20)};
  height: ${ms(20)};
  position: relative;
  top: 1px;
  margin-right: ${ms(10)};
`;

export const Value = styled(Text).attrs({
  nativeProps: {numberOfLines: 1},
  weight: 'semibold',
})`
  color: ${getColor('text1')};
  font-size: ${ms(15)};
  line-height: ${ms(22)};
  letter-spacing: ${ms(-0.4)};
`;

export const PrimaryIcon = styled(CheckIcon).attrs(p => ({
  fill: getColor('global1')(p),
}))`
  width: ${ms(28)};
  height: ${ms(28)};
`;

export const DeleteIcon = styled(CloseIcon).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  width: ${ms(28)};
  height: ${ms(28)};
`;
